import { errorHandler } from '@/app/shared/services/error-handler.js';
import featureFlagsService from '@/app/shared/services/featureFlagsService.js'
import features from "@/app/shared/AppFeatures.js"

export default {

  //#region employees

  fetchEmployeeListItems({ commit }, projectId) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsGet("geo/gradecontrol/employees/findall", { params: { projectId } })
        .then((response) => {
          commit('SET_EMPLOYEES', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },
  addEmployee({ commit }, employee) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/gradecontrol/employees/create', { employee })
        .then((response) => {
          commit('ADD_EMPLOYEE', Object.assign(employee, { employeeId: response.data.model.employeeId }))
          resolve(response)
        })
        .catch((error) => {
          errorHandler.savingError(this._vm, error);
          reject(error); 
        })
    })
  },
  updateEmployee({ commit }, employee) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/gradecontrol/employees/edit', { employee })
        .then((response) => {
          commit('UPDATE_EMPLOYEE', response.data.model)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },
  removeEmployee({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/gradecontrol/employees/delete', { id })
        .then((response) => {
          commit('REMOVE_EMPLOYEE', id)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },

  //#endregion

  //#region MuckTypes

  fetchMuckTypeListItems({ commit }, projectId) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.get("geo/gradecontrol/mucktype", { params: {
        projectId
      }})
        .then((response) => {
          commit('SET_MUCKTYPE', response.data)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },
  addMuckType({ commit }, mucktype) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('geo/gradecontrol/mucktype/', mucktype)
        .then((response) => {
          commit('ADD_MUCKTYPE', Object.assign(mucktype, { muckTypeId: response.data.muckTypeId }))
          resolve(response)
        })
        .catch((error) => {
          errorHandler.savingError(this._vm, error);
          reject(error); 
        })
    })
  },
  updateMuckType({ commit }, mucktype) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('geo/gradecontrol/mucktype/', mucktype)
        .then((response) => {
          commit('UPDATE_MUCKTYPE', response.data)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },
  removeMuckType({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.delete('geo/gradecontrol/mucktype/' + itemId)
        .then((response) => {
          commit('REMOVE_MUCKTYPE', itemId)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },

  //#endregion

  //#region Equipments

  fetchEquipmentListItems({ commit }, projectId) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsGet("geo/gradecontrol/equipments/findall", { params: { projectId } })
        .then((response) => {
          commit('SET_EQUIPMENTS', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },

  addEquipment({ commit }, equipment) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/gradecontrol/equipments/create', { equipment })
        .then((response) => {
          commit('ADD_EQUIPMENT', Object.assign(equipment, { equipmentId: response.data.model.equipmentId }))
          resolve(response)
        })
        .catch((error) => {
          errorHandler.savingError(this._vm, error);
          reject(error); 
        })
    })
  },

  updateEquipment({ commit }, equipment) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/gradecontrol/equipments/edit', { equipment })
        .then((response) => {
          commit('UPDATE_EQUIPMENT', response.data.model)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },

  removeEquipment({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/gradecontrol/equipments/delete', { id })
        .then((response) => {
          commit('REMOVE_EQUIPMENT', id)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },

  //#endregion

  //#region Location

  fetchLocationListItems({ commit }, projectId) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsGet("geo/gradecontrol/locations/findall", { params: { projectId } })
        .then((response) => {
          commit('SET_LOCATIONS', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },

  addLocation({ commit }, location) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/gradecontrol/locations/create', { location })
        .then((response) => {
          commit('ADD_LOCATION', Object.assign(location, { locationId: response.data.model.locationId }))
          resolve(response)
        })
        .catch((error) => {
          errorHandler.savingError(this._vm, error);
          reject(error); 
        })
    })
  },
  updateLocation({ commit }, location) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/gradecontrol/locations/edit', { location })
        .then((response) => {
          commit('UPDATE_LOCATION', response.data.model)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },
  removeLocation({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/gradecontrol/locations/delete', { id })
        .then((response) => {
          commit('REMOVE_LOCATION', id)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },

  //#endregion

  //#region Timesheet
  
  addTimesheet({ commit }, timesheet) {
    return new Promise((resolve, reject) => {
      timesheet.tonnage = this._vm.$systemUnits.convertTonnageToMetric(timesheet.tonnage);
      this._vm.$webApi.post('geo/gradecontrol/timesheetstagingentry/', timesheet)
        .then((response) => {
          response.data.tonnage = this._vm.$systemUnits.convertTonnage(response.data.tonnage);
          commit('ADD_TIMESHEET', response.data)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.savingError(this._vm, error);
          reject(error)
        })
    })
  },

  fetchTimesheetListItems({ commit }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.get("geo/gradecontrol/timesheetstagingentry/", {
        params: {
          projectId: payload.projectId,
          startDate: payload.selectedDate,
          includeDeleted: payload.includeDeleted
        }
      }).then((response) => {
        response.data.forEach(item => {
          if (item.tonnage)
            item.tonnage = this._vm.$systemUnits.convertTonnage(item.tonnage);
        });
        commit('SET_TIMESHEETS', response.data)
        resolve(response) })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },

  clearTimesheetListItems({ commit }) {
    commit('SET_TIMESHEETS', null)  
  },

  updateTimesheet({ commit }, timesheet) {
    return new Promise((resolve, reject) => {
      timesheet.tonnage = this._vm.$systemUnits.convertTonnageToMetric(timesheet.tonnage);
      this._vm.$webApi.post('geo/gradecontrol/timesheetstagingentry/', timesheet)
        .then((response) => {
          response.data.tonnage = this._vm.$systemUnits.convertTonnage(response.data.tonnage);
          commit('UPDATE_TIMESHEET', response.data)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.savingError(this._vm, error);
          reject(error)
        })
    });
  },

  removeTimesheet({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.delete('geo/gradecontrol/timesheetstagingentry/' + itemId)
        .then((response) => {
          commit('REMOVE_TIMESHEET', itemId)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },

  removeTimesheetBatch({ commit }, items) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('geo/gradecontrol/timesheetstagingentry/DeleteBatch/', {
        timesheetsId: items
      })
        .then((response) => {
          response.data.forEach(itemId => {
            commit('REMOVE_TIMESHEET', itemId)
          });
        
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },

  //#endregion

  //#region Importation

  createImportation(payload) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('geo/gradecontrol/TimesheetImportation/', { params: {
        projectId: payload.projectId,
        timesheetsId: payload.timesheetsId
      }})
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },

  //#endregion

  //#region Forecast
  
  fetchLocationForecastListItems({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const params = {
        projectId: payload.projectId,
        startDate: payload.startDate
      };
      if (featureFlagsService.isEnabled(features.Core.ProjectFilter.Nsr)) {
        params.calculation = true;
      }
      this._vm.$webApi.get("geo/gradecontrol/LocationForecast/", { params })
        .then((response) => {
          commit('SET_FORECASTS', response.data)
          resolve(response) })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error);
        })
    })
  },
  
  fetchLocationForecasts({ commit }, locationId) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.get("geo/gradecontrol/LocationForecast/GetByLocation/" + locationId).then((response) => {
        commit('SET_FORECASTS', response.data)
        resolve(response) })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error);
        })
    })
  },

  addForecast({ commit }, forecast) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('geo/gradecontrol/LocationForecast/', forecast)
        .then((response) => {
          commit('ADD_FORECAST', response.data)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.savingError(this._vm, error);
          reject(error); })
    })
  },

  updateForecast({ commit }, forecast) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('geo/gradecontrol/LocationForecast/', forecast)
        .then((response) => {
          commit('UPDATE_FORECAST', response.data)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },

  removeForecast({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.delete('geo/gradecontrol/LocationForecast/' + itemId)
        .then((response) => {
          commit('REMOVE_FORECAST', itemId)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },

  removeForecastBatch({ commit }, items) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('geo/gradecontrol/LocationForecast/DeleteBatch/', {
        locationForecastsId: items
      })
        .then((response) => {
          response.data.forEach(itemId => {
            commit('REMOVE_FORECAST', itemId)
          });
        
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },

  clearForecastListItems({ commit }) {
    commit('SET_FORECASTS', [])  
  },


  fetchForecastMucks({ commit }, locationForecastId) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.get("geo/gradecontrol/Muck/GetByLocationForecast/" + locationForecastId).then((response) => {
        commit('SET_MUCKS', response.data)
        resolve(response) })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },

  fetchForecastMucksIncludeAllMaterialType({ commit }, locationForecastId) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.get("geo/gradecontrol/Muck/GetByLocationForecast/" + locationForecastId, {params: { includeAllMaterialType: true }}).then((response) => {
        commit('SET_MUCKS', response.data)
        resolve(response) })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },

  fetchForecastHaulingsIncludeAllMaterialType({ commit }, locationForecastId) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.get("geo/gradecontrol/Muck/GetHaulingsByLocationForecast/" + locationForecastId, {params: { includeAllMaterialType: true }}).then((response) => {
        commit('SET_HAULINGS', response.data)
        resolve(response) })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },

  fetchForecastStats({ commit }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.get("geo/gradecontrol/LocationForecast/GetStats/" + payload.locationForecastId, {
        params: {
          includeHauling: payload.includeHauling
        }
      }).then((response) => {
        commit('SET_FORECASTSTATS', response.data)
        resolve(response) })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },

  fetchLocationForecastPeriods({ commit }, projectId) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.get("geo/gradecontrol/LocationForecast/GetPeriods/" + projectId).then((response) => {
        commit('SET_FORECASTPERIODLIST', response.data)
        resolve(response) })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },

  fetchPeriodForecastStats({ commit }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.get("geo/gradecontrol/LocationForecast/GetStatsForPeriod/", {
        params: {
          projectId: payload.projectId,
          startDate: payload.startDate,
          endDate: payload.endDate
        }
      }).then((response) => {
        commit('SET_FORECASTSTATSLIST', response.data)
        resolve(response) })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },

  fetchLocationForecastSamples({ commit }, locationForecastId) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.get("geo/gradecontrol/Sample/GetByLocationForecast/" + locationForecastId).then((response) => {
        commit('SET_SAMPLES', response.data)
        resolve(response) })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },
  updateSample({ commit }, sample) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('geo/gradecontrol/Sample/', sample)
        .then((response) => {
          commit('UPDATE_SAMPLE', response.data);
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },


  //#endregion

  //#region Muck

  fetchMuckListItems({ commit }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.get("geo/gradecontrol/Muck/", {
        params: {
          locationId: payload.locationId,
          startDate: payload.startDate,
          endDate: payload.endDate
        }
      }).then((response) => {
        commit('SET_MUCKS', response.data)
        resolve(response) })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },

  clearMuckListItems({ commit }) {
    commit('SET_MUCKS', [])  
  },

  clearHaulingListItems({ commit }) {
    commit('SET_HAULINGS', [])  
  },

  selectMuck({ commit }, muck) {
    commit('SELECT_MUCK', muck)  
  },

  clearSelectedMuck({ commit }) {
    commit('SELECT_MUCK', null)  
  },
  
  updateMuck({ commit }, muck) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('geo/gradecontrol/Muck/', muck)
        .then((response) => {
          commit('UPDATE_MUCK', response.data)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },
  //#endregion
  
  //#region LIMS Samples
  
  fetchLimsSampleListItems({ commit }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.get("geo/gradecontrol/limssampleresult/", {
        params: {
          projectId: payload.projectId,
          startDate: payload.selectedDate
        }
      }).then((response) => {
        commit('SET_LIMSSAMPLES', response.data)
        resolve(response) })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },
  fetchNonApprovedLimsSampleListItems({ commit }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.get("geo/gradecontrol/limssampleresult/GetNonApproved/", {
        params: {
          projectId: payload.projectId,
          startDate: payload.selectedDate
        }
      }).then((response) => {
        commit('SET_LIMSSAMPLES', response.data)
        resolve(response) })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },

  clearSampleListItems({ commit }) {
    commit('SET_LIMSSAMPLES', null)  
  },
  updateLimsSample({ commit }, muck) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('geo/gradecontrol/limssampleresult/', muck)
        .then((response) => {
          commit('UPDATE_LIMSSAMPLE', response.data)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },

  //#endregion

  //#region MuckTypes

  fetchMaterialSubTypeListItems({ commit }, projectId) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.get("geo/gradecontrol/materialsubtype", { params: {
        projectId
      }})
        .then((response) => {
          commit('SET_MATERIALSUBTYPE', response.data)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },
  addMaterialSubType({ commit }, materialSubType) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('geo/gradecontrol/materialsubtype/', materialSubType)
        .then((response) => {
          commit('ADD_MATERIALSUBTYPE', Object.assign(materialSubType, { materialSubTypeId: response.data.materialSubTypeId }))
          resolve(response)
        })
        .catch((error) => {
          errorHandler.savingError(this._vm, error);
          reject(error); 
        })
    })
  },
  updateMaterialSubType({ commit }, materialSubType) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('geo/gradecontrol/materialsubtype/', materialSubType)
        .then((response) => {
          commit('UPDATE_MATERIALSUBTYPE', response.data)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },
  removeMaterialSubType({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.delete('geo/gradecontrol/materialsubtype/' + itemId)
        .then((response) => {
          commit('REMOVE_MATERIALSUBTYPE', itemId)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },

  //#endregion

  //#region destinations

  fetchDestinationListItems({ commit }, projectId) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsGet("geo/destinations/findall", { params: {
        projectId
      }})
        .then((response) => {
          commit('SET_DESTINATIONS', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },
  addDestination({ commit }, destination) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/destinations/create', { destination })
        .then((response) => {
          commit('ADD_DESTINATION', Object.assign(destination, { id: response.data.model.id }))
          resolve(response)
        })
        .catch((error) => {
          errorHandler.savingError(this._vm, error);
          reject(error);
        })
    })
  },
  updateDestination({ commit }, destination) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/destinations/edit/', { destination })
        .then((response) => {
          commit('UPDATE_DESTINATION', response.data.model)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },
  removeDestination({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/destinations/delete/', { id: itemId })
        .then((response) => {
          commit('REMOVE_DESTINATION', itemId)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },

  //#endregion

  //#region remuckForecasts

  fetchRemuckForecastListItems({ commit }, projectId) {
    return new Promise((resolve, reject) => {
      
      this._vm.$cqrsGet("geo/gradeControl/remuckForecast/findAll", { params: {
        projectId
      }})
        .then((response) => {
          commit('SET_REMUCK_FORECASTS', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },
  addRemuckForecast({ commit }, remuckForecast) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/gradeControl/remuckForecast/create', { remuckForecast })
        .then((response) => {
          commit('ADD_REMUCK_FORECAST', Object.assign(remuckForecast, { id: response.data.model.id }))
          resolve(response)
        })
        .catch((error) => {
          errorHandler.savingError(this._vm, error);
          reject(error);
        })
    })
  },
  updateRemuckForecast({ commit }, remuckForecast) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/gradeControl/remuckForecast/edit/', { remuckForecast })
        .then((response) => {
          commit('UPDATE_REMUCK_FORECAST', response.data.model)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },

  //#endregion

  //#region nsrForecasts

  fetchNSRForecastListItems({ commit }, projectId) {
    return new Promise((resolve, reject) => {
      
      this._vm.$cqrsGet("geo/gradeControl/netSmelterReturnForecast/findAll", { params: {
        projectId
      }})
        .then((response) => {
          commit('SET_NSR_FORECASTS', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },
  addNSRForecast({ commit }, netSmelterReturnForecast) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/gradeControl/netSmelterReturnForecast/create', { netSmelterReturnForecast })
        .then((response) => {
          commit('ADD_NSR_FORECAST', Object.assign(netSmelterReturnForecast, { id: response.data.model.id }))
          resolve(response)
        })
        .catch((error) => {
          errorHandler.savingError(this._vm, error);
          reject(error);
        })
    })
  },
  updateNSRForecast({ commit }, netSmelterReturnForecast) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/gradeControl/netSmelterReturnForecast/edit/', { netSmelterReturnForecast })
        .then((response) => {
          commit('UPDATE_NSR_FORECAST', response.data.model)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  }

  //#endregion
}
